const cartItemMessageTemplates = [
    {
        id: 'matched-promotion',
        content: require('./matched-promotion.html').trim(),
    },
    {
        id: 'missed-promotion',
        content: require('./missed-promotion.html').trim(),
    },
    {
        id: 'error-quantity',
        content: require('./error-quantity.html').trim(),
    },
];

module.exports = { cartItemMessageTemplates };



// WEBPACK FOOTER //
// ./src/shop/cart/cartitemmessages/index.js